export const courses = [
  {
    slug: 'curso-twinmotion',
    name: 'Curso de Twinmotion',
    level: 'Nivel inicial',
    mode: 'Online',
    price: 'Gratuito',
    duration: null,
    description:
      'Introducción a la visualización en tiempo real: interfaz, materiales, iluminación y exportación de imágenes y recorridos.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/4f6b0f508a1ad9f8aa089d1dda7b52b6.jpeg',
  },
  {
    slug: 'render-realista-ia',
    name: 'Render Arquitectónico Realista + Postproducción con IA',
    level: 'Nivel intermedio',
    mode: 'Online',
    price: '$700 MXN',
    duration: '+4 horas de contenido',
    description:
      'De la escena al render final: configuración de cámara, iluminación, materiales realistas y postproducción asistida por IA.',
    image:
      'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/eb4be577015a9f0c5861687bab096a13.png',
  },
];